import type { Language } from '../model/language';
import { LocaleCodes } from './localeCodes';

const countryFlagsImagesPrefix = '';

export const Languages: Language[] = [
    { id: 1, name: 'English', isoCode: LocaleCodes.enUS, imagePath: `${countryFlagsImagesPrefix}en-flag.webp` },
    { id: 2, name: 'Français', isoCode: LocaleCodes.frFR, imagePath: `${countryFlagsImagesPrefix}fr-flag.webp` },
    { id: 3, name: 'Italiano', isoCode: LocaleCodes.itIT, imagePath: `${countryFlagsImagesPrefix}it-flag.webp` },
    { id: 4, name: 'Español', isoCode: LocaleCodes.esLATAM, imagePath: `${countryFlagsImagesPrefix}mx-flag.webp` },
    { id: 5, name: 'Deutsch', isoCode: LocaleCodes.deDE, imagePath: `${countryFlagsImagesPrefix}de-flag.webp` },
    { id: 6, name: '繁體中文', isoCode: LocaleCodes.zhTW, imagePath: `${countryFlagsImagesPrefix}cn-flag.webp` },
    { id: 7, name: '日本語', isoCode: LocaleCodes.jaJP, imagePath: `${countryFlagsImagesPrefix}ja-flag.webp` },
    { id: 8, name: 'العربية', isoCode: LocaleCodes.arAE, imagePath: `${countryFlagsImagesPrefix}ar-flag.webp` },
    { id: 9, name: 'فارسی', isoCode: LocaleCodes.faIR, imagePath: `${countryFlagsImagesPrefix}fa-flag.webp` },
    { id: 10, name: '简体中文', isoCode: LocaleCodes.zhCN, imagePath: `${countryFlagsImagesPrefix}cn-flag.webp` },
    {
        id: 11,
        name: 'Português (Brasil)',
        isoCode: LocaleCodes.ptBR,
        imagePath: `${countryFlagsImagesPrefix}br-flag.webp`,
    },
    {
        id: 12,
        name: 'Español (España)',
        isoCode: LocaleCodes.esES,
        imagePath: `${countryFlagsImagesPrefix}es-flag.webp`,
    },
    { id: 13, name: '한국어', isoCode: LocaleCodes.koKR, imagePath: `${countryFlagsImagesPrefix}kr-flag.webp` },
    { id: 14, name: 'हिन्दी', isoCode: LocaleCodes.hiIN, imagePath: `${countryFlagsImagesPrefix}in-flag.webp` },
    { id: 15, name: 'Türkçe', isoCode: LocaleCodes.trTR, imagePath: `${countryFlagsImagesPrefix}tr-flag.webp` },
    { id: 16, name: 'ไทย', isoCode: LocaleCodes.thTH, imagePath: `${countryFlagsImagesPrefix}th-flag.webp` },
    { id: 17, name: 'Русский', isoCode: LocaleCodes.ruRU, imagePath: `${countryFlagsImagesPrefix}ru-flag.webp` },
    { id: 18, name: 'Polski', isoCode: LocaleCodes.plPL, imagePath: `${countryFlagsImagesPrefix}pl-flag.webp` },
    { id: 19, name: 'Nederlands', isoCode: LocaleCodes.nlNL, imagePath: `${countryFlagsImagesPrefix}nl-flag.webp` },
    {
        id: 20,
        name: 'Português (Portugal)',
        isoCode: LocaleCodes.ptPT,
        imagePath: `${countryFlagsImagesPrefix}pt-flag.webp`,
    },
    { id: 21, name: 'Svenska', isoCode: LocaleCodes.svSE, imagePath: `${countryFlagsImagesPrefix}se-flag.webp` },
    { id: 22, name: 'Norsk', isoCode: LocaleCodes.nbNO, imagePath: `${countryFlagsImagesPrefix}no-flag.webp` },
    { id: 23, name: 'Íslenska', isoCode: LocaleCodes.isIS, imagePath: `${countryFlagsImagesPrefix}is-flag.webp` },
];
